<div class="pt-3" *ngIf="loadingOrganizationConfig">
  <h2>Loading...</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pl-md-4 pt-4 pb-5" *ngIf="!loadingOrganizationConfig && (serverError === null)">

  <h3 class="mb-4">Configure Check-In/Out Sounds</h3>

  <div class="row">
    <div class="col-lg-6 order-lg-last mb-4 mb-lg-0">
      <h5 class="mb-1">Success Sound Priority</h5>
      <p class="text-muted small mb-2">
        When multiple success conditions apply to a check-in, the higher-priority sound plays.
      </p>
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th style="width: 90px;">Priority</th>
            <th>Sound</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of SuccessSoundPriority; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-6">
      <div class="form-group" *ngFor="let checkInSoundItem of CheckInSoundItems">
        <label [for]="checkInSoundItem.fieldName">
          {{ checkInSoundItem.name }}
        </label>
        <select id="SuccessSelectLoading" class="custom-select"
                *ngIf="loadingBuiltInSounds" disabled>
          <option>Loading...</option>
        </select>
        <div class="input-group">
          <select class="custom-select"
                  [id]="checkInSoundItem.fieldName"
                  [name]="checkInSoundItem.fieldName"
                  *ngIf="!loadingBuiltInSounds"
                  [(ngModel)]="organizationConfig[checkInSoundItem.fieldName]"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="null">No Sound</option>
            <option *ngFor="let builtInSound of builtInSounds"
                    [ngValue]="builtInSound.id">{{ builtInSound.name }}
            </option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-secondary"
                    (click)="playSound(organizationConfig[checkInSoundItem.fieldName])"
                    [class.disabled]="!organizationConfig[checkInSoundItem.fieldName]"
                    [disabled]="!organizationConfig[checkInSoundItem.fieldName]">
              Play Sound
            </button>
          </div>
        </div>
        <small class="form-text text-muted">
          {{ checkInSoundItem.helpText }}
        </small>
        <div class="form-text text-danger">{{ errors[checkInSoundItem.fieldName] }}</div>
      </div>

      <div class="alert alert-success" role="alert" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button class="btn btn-primary float-right"
              *ngIf="!savingOrganizationConfig"
              (click)="saveOrganizationConfig()">
        Save
      </button>
      <button class="btn btn-primary float-right disabled" disabled
              *ngIf="savingOrganizationConfig">
        Loading...
      </button>
      <button class="btn btn-secondary" (click)="loadOrganizationConfig()">
        Cancel
      </button>

    </div>
  </div>
</div>
